import Button from "../components/Button";
import { useNavigate } from "react-router";
import { useTranslation } from "../i18n/TranslationProvider";

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="custom-container mx-auto w-4/5 md:w-2/3 lg:w-1/2 ">
      <h3 className="text-center text-lg md:text-2xl mb-2">
        {t("notFound.heading")}
      </h3>
      <p className="text-center">{t("notFound.subtext")}</p>
      <Button
        className="mx-auto mt-6"
        variant="outline"
        onClick={() => navigate(-1)}
      >
        {t("common.goBackArrow")}
      </Button>
    </div>
  );
}